import React from "react";

type Props = {};

const Footer = (props: Props) => {
  return (
    <div className="text-[16px] text-[#1e1e1e] flex items-center justify-center space-x-2 h-12">
      <span>Copyright {new Date().getFullYear()}</span>
      <div className="w-[10px] h-[10px] bg-[#81B465] rounded-full"></div>
      <span>All right reserved</span>
      <div className="w-[10px] h-[10px] bg-[#81B465] rounded-full"></div>
      <span>OSB</span>
    </div>
  );
};

export default Footer;
